<template>
	<div class="withdrawalRecord-user" :style="{ '--height': height, }">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title" v-if="type == 2">{{ $t("head.top_up") }}</div>
			<div class="title" v-else>{{ $t("head.withdrawalRecord") }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>
		<div class="time-screening">
			<div class="date" @click="dateShow = true">
				<span>{{ date_1 }}</span>
				<van-icon name="notes-o" size="20" />
			</div>
			<div class="to">{{ $t('balance.to') }}</div>
			<div class="date" @click="dateShow = true">
				<span>{{ date_2 }}</span>
				<van-icon name="notes-o" size="20" />
			</div>
			<div class="btn" @click="screening">
				{{ $t("transactiondetails.select") }}
			</div>
		</div>
		<div class="money">
			<p @click="changeMoneyType('USDT')" :class="moneyType == 'USDT' ? 'active' : ''">
				USDT
			</p>
			<p @click="changeMoneyType('TRX')" :class="moneyType == 'TRX' ? 'active' : ''">
				TRX
			</p>
		</div>
		<van-calendar v-model="dateShow" type="range" color="#161414" allow-same-day :min-date="minDate"
			@confirm="onConfirm" />
		<ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto">
			<div v-if="rechargeRecordlist.length < 1" style="padding:  3rem 0;color: #ffffff;text-align: center;">
				{{ $t("transactiondetails.not") }}
			</div>
			<div v-else class="details-lists" v-for="(item, index) in rechargeRecordlist" :key="index">
				<div class="item-top">
					<p>{{ item.name }}</p>
					<p>{{ type == 2 ? '+' : '-' }}{{ item.flowPrice }}</p>
				</div>
				<div class="item-bottom">
					<p>{{ item.createTime }}</p>
					<p>{{ $t("withdrawalRecord.afterPrice") }}：{{ item.afterPrice }}</p>
				</div>
			</div>
		</ul>
	</div>
</template>

<script>
import {
	withdrawRecord,
	rechargeRecord
} from "@/utils/request";
export default {
	data() {
		return {
			moneyType: "USDT",
			number: 10,
			monthValue: "",
			type: '', //2：充值记录
			size: "20",
			current: 1,
			datetime: '',
			rechargeRecordlist: [],
			height: '',//屏幕高度
			tips: this.$t("withdrawalRecord.Select_month"),
			date_1: '',
			date_2: '',
			dateShow: false,
			minDate: new Date(2021, 0, 1)
		};
	},
	//获取屏幕高度
	created() {
		let h = document.documentElement.clientHeight || document.body.clientHeight;
		if (h > 0) {
			this.height = h + 'px' //页面高度
		} else {
			this.height = "100vh"
		}
	},
	mounted() {
		this.type = this.$route.query.type
		this.withdrawRecord()
	},
	methods: {
		onConfirm(date) {
			this.date_1 = date[0].getFullYear() + '-' + (date[0].getMonth() + 1) + '-' + date[0].getDate()
			this.date_2 = date[1].getFullYear() + '-' + (date[1].getMonth() + 1) + '-' + date[1].getDate()
			console.log(this.date_1, this.date_2)
			this.dateShow = false
		},
		screening() {
			let that = this
			this.current = 1
			if (that.date_1 && that.date_2) {
				that.datetime = that.date_1 + ' ~ ' + that.date_2
			}
			this.withdrawRecord()
		},
		withdrawRecord() { //提现记录
			var that = this
			if (that.type == 2) {
				rechargeRecord({
					time: that.datetime,
					size: that.size,
					current: that.current,
					coin: that.moneyType
				}).then((res) => {
					if (res.code == "200") {
						that.rechargeRecordlist = res.data.records
					}
				});
			} else {
				withdrawRecord({
					time: that.datetime,
					size: that.size,
					current: that.current,
					coin: that.moneyType
				}).then((res) => {
					if (res.code == "200") {
						that.rechargeRecordlist = res.data.records
					}
				});
			}
		},
		chooseData(value) {
			console.log(value);
		},
		load() {
			var that = this
			if (that.type == 2) {
				rechargeRecord({
					time: that.datetime,
					size: that.size,
					current: that.current + 1,
					coin: that.moneyType
				}).then((res) => {
					if (res.code == "200") {
						if (res.data.records.length > 0) {
							that.current += 1
							that.rechargeRecordlist = [...that.rechargeRecordlist, ...res.data.records]
						}
					}
				});
			} else {
				withdrawRecord({
					time: that.datetime,
					size: that.size,
					current: that.current + 1,
					coin: that.moneyType
				}).then((res) => {
					if (res.code == "200") {
						if (res.data.records.length > 0) {
							that.current += 1
							that.rechargeRecordlist = [...that.rechargeRecordlist, ...res.data.records]
						}
					}
				});
			}
		},
		//选择币种类型
		changeMoneyType(item) {
			this.moneyType = item;
			this.current = 1
			this.withdrawRecord()
		},
		toBack() {
			this.$router.push("/user");
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
	width: 7.5rem;
}

.time-screening {
	display: flex;
	height: 2.6875rem;
	background: #0c0b0b;
	border-radius: 0.25rem;
	padding: 0 0.9375rem;
	margin-bottom: 10px;

	.date {
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 7.5rem;
		height: 2.6875rem;
		padding: 0 0.625rem;
		background: #161414;
		border-radius: 0.25rem;
		font-size: 0.8125rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #999999;
	}

	.to {
		margin: 0 0.6875rem;
		font-size: 0.8125rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #ffffff;
		line-height: 2.6875rem;
	}

	.btn {
		width: 3.75rem;
		height: 2.6875rem;
		margin-left: 0.625rem;
		border-radius: 0.3125rem;
		border: 1px solid #f8c007;
		font-size: 0.9375rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #f8c007;
		line-height: 2.6875rem;
		text-align: center;
	}
}

.withdrawalRecord-user {
	width: 100vw;
	height: var(--height);
	background: #0c0b0b;

	.data-time-picker {
		height: 4rem;
		padding-left: .9375rem;
	}

	.infinite-list {
		height: calc(var(--height) - 11.75rem);
	}

	.details-lists {
		padding: 0.9375rem 0.9375rem;
		border-bottom: 0.0625rem solid #272727;

		.item-top {
			display: flex;
			justify-content: space-between;
			padding-bottom: 0.5rem;

			>p {
				font-size: 0.8125rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
			}
		}

		.item-bottom {
			display: flex;
			justify-content: space-between;

			>p {
				font-size: 0.8125rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}
		}
	}

	.money {
		display: flex;
		justify-content: space-around;
		padding: 1rem 0;

		.active {
			color: #ffc400 !important;
			border-bottom: 0.0625rem solid #ffc400;
		}

		>p {
			font-size: 0.875rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #999999;
			padding-bottom: 0.25rem;
		}
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/user/withdrawalRecord.vue